<template>
  <div
    v-if="!comment"
    class="total-likes"
  >
    <pop-up
      v-if="showLikeUsers"
    >
      <li
        v-for="(like, index) in likes"
        :key="`like${index}`"
      >
        <button
          type="button"
          class="btn btn-transparent"
          @click="showUserProfile(like.user)"
        >
          {{ like.user.first_name }} {{ like.user.last_name }}
        </button>
      </li>
    </pop-up>

    <button
      type="button"
      class="btn btn-transparent"
      @click="showLikeUsers = !showLikeUsers"
    >
      {{ pluralize(totalLikes, 'like') }}
    </button>
  </div>
  <div
    v-else
    class="total-likes-comment"
  >
    <pop-up
      v-if="showLikeUsers"
      :dropup="true"
      :align-right="true"
    >
      <li
        v-for="(like, index) in likes"
        :key="`like${index}`"
      >
        <button
          type="button"
          class="btn btn-transparent"
          @click="showUserProfile(like.user)"
        >
          {{ like.user.first_name }} {{ like.user.last_name }}
        </button>
      </li>
    </pop-up>

    <button
      type="button"
      class="btn btn-transparent"
      @click="showLikeUsers = !showLikeUsers"
    >
      <thumb-up-icon />
      {{ totalLikes }}
    </button>
  </div>
</template>

<script>
import PopUp from '@/components/PopUp.vue';

export default {
  name: 'TotalLikes',
  components: {
    PopUp,
  },
  props: {
    comment: {
      type: Boolean,
      required: true,
    },
    totalLikes: {
      type: Number,
      required: true,
    },
    likes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showLikeUsers: false,
    };
  },
  methods: {
    showUserProfile(user) {
      this.$router.push({ name: 'profile', params: { id: user.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.total-likes {
  display: inline;
  margin-left: 1rem;
}
.total-likes-comment {
  .btn {
    font-size: 80%;
  }
}
</style>
